/**
 * Copyright (c) 2018-2023, BOTLabs GmbH.
 *
 * This source code is licensed under the BSD 4-Clause "Original" license
 * found in the LICENSE file in the root directory of this source tree.
 */
/* eslint-disable no-bitwise */
export const Permission = {
    ATTEST: 1 << 0,
    DELEGATE: 1 << 1, // 0010
};
